import React, { useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import AuthUser from "./AuthUser";

const ResetPassword = () => {
    const { token } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { http, setToken } = AuthUser();
    const email = searchParams.get("email");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        try {
            const response = await http.post("/reset-password", {
                token,
                email,
                password,
                password_confirmation: confirmPassword,
            });

            setMessage("✅ Password reset successfully. You can now log in.");
            setTimeout(() => navigate("/login"), 2500);

        } catch (error) {
            if (error.response && error.response.data) {
                setError(error.response.data.message || "Something went wrong.");
            } else {
                setError("Server error. Try again later.");
            }
        }
    };

    return (

        <div className="bg-color">
            <div className="containerr h-100  d-flex justify-content-center align-items-center">
                <div className="containerr d-flex justify-content-center align-items-center">
                    <div className="col-lg-7 h100 d-flex flex-column justify-content-center align-items-center bg-w">
                        <div className="rounded text-black">
                            <div className="user-log-img">
                                <Link to="/">
                                    <img src="/assets/img/logo/header-logo10a.svg" alt="" />
                                </Link>
                                <img className="user-img" src="/assets/img/images/Annual-Compliance-LLP.png" alt="" />
                            </div>
                            <div className="txtt text-center">
                                <h4 className="user-login-txt">"Secure your legal needs with ease. Log in and take the next step towards hassle-free legal solutions."</h4>
                            </div>
                        </div>

                    </div>
                    <div className="col-lg-5 h100  d-flex flex-column  justify-content-center align-items-center bg-g">

                        <div className=" card form-sec rounded-3 color text-black">
                            <div className="card-body  mx-2">

                                <div >
                                    <h2 className="text-center">Reset Your Password</h2>

                                    <form onSubmit={handleSubmit} style={styles.form}>
                                        <input
                                            type="password"
                                            placeholder="New password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                            style={styles.input}
                                        />
                                        <input
                                            type="password"
                                            placeholder="Confirm new password"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            required
                                            style={styles.input}
                                        />
                                        <button type="submit" style={styles.button}>Reset Password</button>
                                    </form>

                                    {message && <p style={styles.success}>{message}</p>}
                                    {error && <p style={styles.error}>{error}</p>}
                                </div>
                            </div>
                        </div>




                    </div>

                </div>

            </div>
        </div>

    );
};

const styles = {
    container: {
        maxWidth: "400px",
        margin: "50px auto",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        textAlign: "center",
        background: "#fff",
        border: "2px solid #00a6ff"

    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: "12px"
    },
    input: {
        padding: "10px",
        fontSize: "16px",
        borderRadius: "5px",
        border: "1px solid #ccc"
    },
    button: {
        padding: "10px",
        fontSize: "16px",
        backgroundColor: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer"
    },
    success: {
        color: "green",
        marginTop: "15px"
    },
    error: {
        color: "red",
        marginTop: "15px"
    }
};

export default ResetPassword;
